import ParamTypes from 'Models/history/paramTypes';
import { useParams as useRouterParams } from 'react-router-dom';

function useParams<T extends ParamTypes>() {
	return useRouterParams<T>();
}
export default useParams;
